import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../../../../../ingredients/services";
import { Globals } from "../../../../../../globals";
import { ProductsServices } from '../../../../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ProductPartialFoodcostIngSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-partial-foodcost-ing-selected',
  templateUrl: 'product-partial-foodcost-ing-selected.html',
})
export class ProductPartialFoodcostIngSelectedPage {

  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public productsServices: ProductsServices,
    public translate: TranslateService,) {
  }

  ionViewWillEnter() {
  }

  delete(element) {
    var index = this.productsServices.prodings_array_tmp.findIndex(x => x[0] == element[0]);
    if (index >= 0) {
      this.productsServices.prodings_array_tmp.splice(index, 1);
      this.productsServices.prodings_array_tmp = [...this.productsServices.prodings_array_tmp];
    }
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.delete(event.row);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-foodcost/product-create-foodcost-select-ing/product-partial-foodcost-ing-selected/product-partial-foodcost-ing-selected.ts